// tslint:disable ordered-imports

// Import storyContent contents
import Header1 from '../html/header-1.html';
import Header2 from '../html/header-2.html';
import Header3 from '../html/header-3.html';
import FullWidth1 from '../html/full-width-1.html';
import FullWidth2 from '../html/full-width-2.html';
import FullWidth3 from '../html/full-width-3.html';
import FullWidth4 from '../html/full-width-4.html';
import FullWidth5 from '../html/full-width-5.html';
import LeftRightMedia1 from '../html/left-right-media-1.html';
import LeftRightMedia2 from '../html/left-right-media-2.html';
import TwoColumns1 from '../html/two-columns-1.html';
import TwoColumns2 from '../html/two-columns-2.html';
import TwoColumns3 from '../html/two-columns-3.html';
import ProposalSummary from '../html/proposal-summary.html';
import ThreeColumns1 from '../html/three-columns-1.html';
import ThreeColumns2 from '../html/three-columns-2.html';
import ThreeColumns3 from '../html/three-columns-3.html';
import Gallery1 from '../html/gallery-1.html';
import Footer1 from '../html/footer-1.html';

// Import storyContent thumbnails
import Header1SVG from '../svg/header-1.svg';
import Header2SVG from '../svg/header-2.svg';
import Header3SVG from '../svg/header-3.svg';
import FullWidth1SVG from '../svg/full-width-1.svg';
import FullWidth2SVG from '../svg/full-width-2.svg';
import FullWidth3SVG from '../svg/full-width-3.svg';
import FullWidth4SVG from '../svg/full-width-4.svg';
import FullWidth5SVG from '../svg/full-width-5.svg';
import LeftRightMedia1SVG from '../svg/left-right-media-1.svg';
import LeftRightMedia2SVG from '../svg/left-right-media-2.svg';
import TwoColumns1SVG from '../svg/two-columns-1.svg';
import TwoColumns2SVG from '../svg/two-columns-2.svg';
import TwoColumns3SVG from '../svg/two-columns-3.svg';
import ThreeColumns1SVG from '../svg/three-columns-1.svg';
import ThreeColumns2SVG from '../svg/three-columns-2.svg';
import ThreeColumns3SVG from '../svg/three-columns-3.svg';
import Footer1SVG from '../svg/footer-1.svg';

// Constants for each storyContent group and format
import {
  BODY_CONTENT,
  HEADER,
  HEADER_1,
  HEADER_2,
  HEADER_3,
  FULL_WIDTH,
  FULL_WIDTH_1,
  FULL_WIDTH_2,
  FULL_WIDTH_3,
  FULL_WIDTH_4,
  FULL_WIDTH_5,
  LEFT_RIGHT_MEDIA,
  LEFT_RIGHT_MEDIA_1,
  LEFT_RIGHT_MEDIA_2,
  TWO_COLUMNS,
  TWO_COLUMNS_1,
  TWO_COLUMNS_2,
  TWO_COLUMNS_3,
  PROPOSAL_SUMMARY,
  THREE_COLUMNS,
  THREE_COLUMNS_1,
  THREE_COLUMNS_2,
  THREE_COLUMNS_3,
  GALLERY,
  GALLERY_1,
  FOOTER,
  FOOTER_1
} from '../constants';
import { IStoryContent } from '../types';
import cheerio from 'cheerio';

export function selectNewStoryContents() {
  return [
    {
      content: Header1,
      order: 1,
      format: HEADER_1,
      title: 'Header',
      type: HEADER,
      active: true,
      description: 'Header 1 - left aligned',
      group: HEADER,
      thumbnail: Header1SVG
    },
    {
      content: Header2,
      order: 2,
      format: HEADER_2,
      title: 'Header',
      type: HEADER,
      description: 'Header 2 - center aligned',
      group: HEADER,
      thumbnail: Header2SVG
    },
    {
      content: Header3,
      order: 3,
      format: HEADER_3,
      title: 'Header',
      type: HEADER,
      description: 'Header 3 - left aligned with navigation',
      group: HEADER,
      thumbnail: Header3SVG
    },
    {
      content: FullWidth1,
      order: 1,
      format: FULL_WIDTH_1,
      title: 'Full-Width',
      type: BODY_CONTENT,
      active: true,
      description: 'Full-width 1 - heading and text',
      group: FULL_WIDTH,
      thumbnail: FullWidth1SVG
    },
    {
      content: FullWidth2,
      order: 2,
      format: FULL_WIDTH_2,
      title: 'Full-Width',
      type: BODY_CONTENT,
      description: 'Full-width 2 - media and text',
      group: FULL_WIDTH,
      thumbnail: FullWidth2SVG
    },
    {
      content: FullWidth3,
      order: 3,
      format: FULL_WIDTH_3,
      title: 'Full-Width',
      type: BODY_CONTENT,
      description: 'Full-width 3 - media',
      group: FULL_WIDTH,
      thumbnail: FullWidth3SVG
    },
    {
      content: FullWidth4,
      order: 4,
      format: FULL_WIDTH_4,
      title: 'Full-Width',
      type: BODY_CONTENT,
      description: 'Full-width 4 - heading and media',
      group: FULL_WIDTH,
      thumbnail: FullWidth4SVG
    },
    {
      content: FullWidth5,
      order: 5,
      format: FULL_WIDTH_5,
      title: 'Full-Width',
      type: BODY_CONTENT,
      description: 'Full-width 5 - text',
      group: FULL_WIDTH,
      thumbnail: FullWidth5SVG
    },
    {
      content: LeftRightMedia1,
      order: 1,
      format: LEFT_RIGHT_MEDIA_1,
      title: 'Left-Right',
      type: BODY_CONTENT,
      description: 'Left-right 1 - left media, right text',
      group: LEFT_RIGHT_MEDIA,
      thumbnail: LeftRightMedia1SVG
    },
    {
      content: LeftRightMedia2,
      order: 2,
      format: LEFT_RIGHT_MEDIA_2,
      title: 'Left-Right',
      type: BODY_CONTENT,
      description: 'Left-right 2 - right media, left text',
      group: LEFT_RIGHT_MEDIA,
      thumbnail: LeftRightMedia2SVG
    },
    {
      content: ThreeColumns1,
      order: 1,
      format: THREE_COLUMNS_1,
      title: 'Three-Columns',
      type: BODY_CONTENT,
      description: 'Three-columns 1 - media, heading and text',
      group: THREE_COLUMNS,
      thumbnail: ThreeColumns1SVG
    },
    {
      content: ThreeColumns2,
      order: 2,
      format: THREE_COLUMNS_2,
      title: 'Three-Columns',
      type: BODY_CONTENT,
      description: 'Three-columns 2 - heading and text',
      group: THREE_COLUMNS,
      thumbnail: ThreeColumns2SVG
    },
    {
      content: ThreeColumns3,
      order: 3,
      format: THREE_COLUMNS_3,
      title: 'Three-Columns',
      type: BODY_CONTENT,
      description: 'Three-columns 3 - media',
      group: THREE_COLUMNS,
      thumbnail: ThreeColumns3SVG
    },
    {
      content: TwoColumns1,
      order: 1,
      format: TWO_COLUMNS_1,
      title: 'Two-Columns',
      type: BODY_CONTENT,
      description: 'Two-columns 1 - media, heading and text',
      group: TWO_COLUMNS,
      thumbnail: TwoColumns1SVG
    },
    {
      content: TwoColumns2,
      order: 2,
      format: TWO_COLUMNS_2,
      title: 'Two-Columns',
      type: BODY_CONTENT,
      description: 'Two-columns 2 - heading and text',
      group: TWO_COLUMNS,
      thumbnail: TwoColumns2SVG
    },
    {
      content: TwoColumns3,
      order: 3,
      format: TWO_COLUMNS_3,
      title: 'Two-Columns',
      type: BODY_CONTENT,
      description: 'Two-columns 3 - media',
      group: TWO_COLUMNS,
      thumbnail: TwoColumns3SVG
    },
    // Following section not available for use in stories, utilized for proposal printing
    {
      content: ProposalSummary,
      order: 1,
      format: PROPOSAL_SUMMARY,
      title: 'Proposal-Summary',
      type: BODY_CONTENT,
      description: 'Proposal Summary',
      group: PROPOSAL_SUMMARY
    },
    {
      content: Gallery1,
      order: 3,
      format: GALLERY_1,
      title: 'Gallery',
      type: BODY_CONTENT,
      description: 'Gallery 1',
      group: GALLERY,
      thumbnail: ThreeColumns3SVG
    },
    {
      content: Footer1,
      order: 1,
      format: FOOTER_1,
      title: 'Footer',
      type: FOOTER,
      active: true,
      description: 'Footer',
      group: FOOTER,
      thumbnail: Footer1SVG
    }
  ];
}
export function selectContentGroups() {
  return [FULL_WIDTH, LEFT_RIGHT_MEDIA, TWO_COLUMNS, THREE_COLUMNS, GALLERY];
}

export const fetchFullWidthLayouts = (storyContentHtml: string): { format: string; thumbnail: string }[] => {
  const $ = cheerio.load(storyContentHtml);
  // check if any element has class has-media
  const hasMedia = $('.has-media').length > 0;
  const filterLayouts = [
    {
      format: FULL_WIDTH_4,
      thumbnail: FullWidth4SVG
    },
    {
      format: FULL_WIDTH_3,
      thumbnail: FullWidth3SVG
    },
    {
      format: FULL_WIDTH_2,
      thumbnail: FullWidth2SVG
    },
  ]
  if (!hasMedia) {
    filterLayouts.push({
      format: FULL_WIDTH_1,
      thumbnail: FullWidth1SVG
    },
    {
      format: FULL_WIDTH_5,
      thumbnail: FullWidth5SVG
    })
  }
  return filterLayouts;
};

export const fetchTwoColumnsLayouts = (storyContentHtml: string): { format: string; thumbnail: string }[] => {
  const $ = cheerio.load(storyContentHtml);
  const hasMedia = $('.has-media').length > 0;
  const filterLayouts = [
    {
      format: TWO_COLUMNS_1,
      thumbnail: TwoColumns1SVG
    },
    {
      format: TWO_COLUMNS_3,
      thumbnail: TwoColumns3SVG
    }
  ]
  if (!hasMedia) {
    filterLayouts.push({
      format: TWO_COLUMNS_2,
      thumbnail: TwoColumns2SVG
    })
  }
  return filterLayouts;
}

export const fetchThreeColumnsLayouts = (storyContentHtml: string): { format: string; thumbnail: string }[] => {
  const $ = cheerio.load(storyContentHtml);
  const hasMedia = $('.has-media').length > 0;
  const filterLayouts = [
    {
      format: THREE_COLUMNS_1,
      thumbnail: ThreeColumns1SVG
    },
    {
      format: THREE_COLUMNS_3,
      thumbnail: ThreeColumns3SVG
    }
  ]
  if (!hasMedia) {
    filterLayouts.push({
      format: THREE_COLUMNS_2,
      thumbnail: ThreeColumns2SVG
    })
  }
  return filterLayouts;
}

export function selectStoryContentFormats(storyContent: IStoryContent): { format: string; thumbnail: any }[] {
  const group = storyContent.group;
  switch (group) {
    case HEADER:
      return [
        {
          format: HEADER_1,
          thumbnail: Header1SVG
        },
        {
          format: HEADER_2,
          thumbnail: Header2SVG
        },
        {
          format: HEADER_3,
          thumbnail: Header3SVG
        }
      ];
    case FULL_WIDTH:
      return fetchFullWidthLayouts(storyContent.content);
    case LEFT_RIGHT_MEDIA:
      return [
        {
          format: LEFT_RIGHT_MEDIA_1,
          thumbnail: LeftRightMedia1SVG
        },
        {
          format: LEFT_RIGHT_MEDIA_2,
          thumbnail: LeftRightMedia2SVG
        }
      ];
    case TWO_COLUMNS:
      return fetchTwoColumnsLayouts(storyContent.content);
    case THREE_COLUMNS:
      return fetchThreeColumnsLayouts(storyContent.content);
    case GALLERY:
      return [
        {
          format: GALLERY_1,
          thumbnail: ThreeColumns3SVG
        }
      ];
    case FOOTER:
      return [
        {
          format: FOOTER_1,
          thumbnail: Footer1SVG
        }
      ];
    default:
      return [];
  }
}
